module.exports = __webpack_public_path__ + "static/media/alligator_ladies_strap_dark_blue.fe0b4f90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alligator_ladies_strap_dark_blue.png
// module id = 122
// module chunks = 0